import React, { useContext, useEffect, useState } from 'react';
import { FooterProps, HeaderProps } from '@spotify-internal/masthead-react';

import { getMasthead } from 'utils/masthead/masthead';

import { MarketContext } from './market';
import { useVerticalConfig } from './vertical';

interface MastheadProviderProps {
  isPlain: boolean;
  children: React.ReactNode;
}

interface MastheadData {
  header?: HeaderProps;
  footer?: FooterProps;
}

const MastheadContext = React.createContext<MastheadData>({});

export function useMastheadData() {
  return useContext(MastheadContext);
}

const MastheadProvider: React.FC<MastheadProviderProps> = ({ children, isPlain }) => {
  const { marketCode } = useContext(MarketContext);
  const {
    features: { configureMasthead },
  } = useVerticalConfig();

  const [header, setHeader] = useState<HeaderProps>();
  const [footer, setFooter] = useState<FooterProps>();

  useEffect(() => {
    const getMastheadData = async () => {
      const res = await getMasthead(marketCode);
      setFooter(res.footer);
      setHeader(res.header);
    };
    if (!configureMasthead && !isPlain) {
      getMastheadData();
    }
  }, [marketCode, isPlain, configureMasthead]);

  return <MastheadContext.Provider value={{ header, footer }}>{children}</MastheadContext.Provider>;
};

export default MastheadProvider;
